// 首页
import request from '@/utils/request'

// 每日警告走势
export function findWarningStatisticByScope(params) {
  return request({
    url: 'v3/report/findWarningStatisticByScope',
    method: 'post',
    data: params
  })
}

// 下拉框客户名称
export function listByCompanyParentId(params) {
  return request({
    url: 'v3/user/company/listByCompanyParentId',
    method: 'post',
    data: params
  })
}

// 警告数据列表
export function listWarningPushMsg2(params) {
  return request({
    url: 'v3/report/listWarningPushMsg2',
    method: 'post',
    data: params
  })
}
// 弹窗--提交
export function updatePushMsgDelFlag(params) {
  return request({
    url: 'v3/report/updatePushMsgDelFlag',
    method: 'post',
    data: params
  })
}
// 下载
export function exportWarningPushMsgCsv(params) {
  return request({
    url: 'v3/report/exportWarningPushMsgCsv',
    method: 'get',
    data: params
  })
}
// 警告配置页
// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 获取单个的配置
export function getwarningSettingByMcuId(params) {
  return request({
    url: '/v3/manager/getwarningSettingByMcuId',
    method: 'post',
    data: params
  })
}
// 配置--提交
export function updateWarningSetting(params) {
  return request({
    url: '/v3/manager/updateWarningSetting',
    method: 'post',
    data: params
  })
}
// 根据 mcuId 获取告警
export function warningListByMcuId(params) {
  return request({
    url: '/v3/report/warningListByMcuId',
    method: 'post',
    data: params
  })
}
// 手动处理单条告警
// export function updatePushMsgDelFlag(params) {
//   return request({
//     url: '/v3/report/updatePushMsgDelFlag',
//     method: 'post',
//     data: params
//   })
// }
// 手动处理全部告警
export function updateAllPushMsgDelFlag(params) {
  return request({
    url: '/v3/report/updateAllPushMsgDelFlag',
    method: 'post',
    data: params
  })
}
// 查询设备电子围栏情况
export function findGeofenceDeviceList(params) {
  return request({
    url: '/v3/manager/geofence/findGeofenceDeviceList',
    method: 'post',
    data: params
  })
}
// 根据mucId获取公司用户, 绑定设备推送人之前调用
export function getCompanyUserName(params) {
  return request({
    url: '/v3/manager/getCompanyUserName',
    method: 'post',
    data: params
  })
}
// 查询设备绑定的推送人
export function selectByMcuId(params) {
  return request({
    url: '/v3/manager/selectByMcuId',
    method: 'post',
    data: params
  })
}
// 新增、修改设备绑定推送人
export function updatePushMsgUser(params) {
  return request({
    url: '/v3/manager/updatePushMsgUser',
    method: 'post',
    data: params
  })
}
// 修改电子围栏
export function updateGnssGeofenceStatus(params) {
  return request({
    url: '/v3/manager/geofence/updateGnssGeofenceStatus',
    method: 'post',
    data: params
  })
}
// 获取锂电池信息
export function getLastOneMsgBMSData(params) {
  return request({
    url: '/v3/canbus/getLastOneMsgBMSData',
    method: 'post',
    data: params
  })
}
// 通过公司id获取用户
export function getGroupCompanyUserList(params) {
  return request({
    url: '/v3/manager/getGroupCompanyUserList',
    method: 'get'
  })
}
// 新增/更新订阅消息
export function saveOrUpdate(params) {
  return request({
    url: '/v3/manager/saveOrUpdate',
    method: 'post',
    data: params
  })
}
// 新增/更新警告消息
export function insertYhubWarningSettingLog(params) {
  return request({
    url: '/v3/manager/insertYhubWarningSettingLog',
    method: 'post',
    data: params
  })
}
// 获取订阅消息
export function getByMcuId(params) {
  return request({
    url: '/v3/manager/getByMcuId?mcuId=' + params,
    method: 'get'
  })
}
